<template>
  <div v-loading="ladingFlag" class="pl-app common-sub-app">
    <micro-app
      ref="micro"
      class="microAppClassName"
      style="height: 100%"
      :name="name"
      :url="pageUrl"
      keep-alive
      baseroute="/st-3pl"
      disable-memory-router
      disable-patch-request
      keep-router-state
      :data="microAppData"
      @datachange="handleDataChange"
      @created="handleCreate"
      @beforemount="handleBeforeMount"
      @mounted="handleMount"
      @unmount="handleUnmount"
      @error="handleError"
      @beforeshow="beforeshow"
      @aftershow="aftershow"
    />
  </div>
</template>

<script>
import urlConfig from './urlConfig'
import { SappModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import Cookies from 'js-cookie'
export default {
  name: 'PLApp',
  data() {
    let envStr = process.env.VUE_APP_ENV || ''
    const itmsSite = Cookies.get('itms-site') || 'sg'
    if (this.getEnvironment() === 1) {
      itmsSite === 'eu' && (envStr = 'siteEu')
    } else if (this.getEnvironment() === 2) {
      itmsSite === 'eu' && (envStr = 'siteEuGray')
    }
    return {
      // data只接受对象类型，数据变化时会重新发送
      microAppData: {
        type: {
          name: 'sender-3pl',
          data: {
            editableTab: SappModule.editableTabs,
            fullname: UserModule.fullname,
            username: UserModule.username,
            siteCode: UserModule.siteCode,
            siteName: UserModule.siteName,
            email: UserModule.email,
            opened: SappModule.sidebar.opened,
            butsPermission: SappModule.butsPermission
          },
          editableTab: SappModule.editableTabs
        },
        pushState: (to) => {}
      },
      name: '3pl',
      pageUrl: urlConfig.server3pl[envStr],
      ladingFlag: false
    }
  },
  computed: {
    fullName() {
      return UserModule.fullname
    },
    userPin() {
      return UserModule.userPin
    }
  },
  mounted() {
    // console.log(this.pageUrl, 'pageUrl')
    // // fullName: this.fullName,
    // //   userPin: this.userPin
    this.microAppData.type.data = {
      fullname: UserModule.username,
      fullName: UserModule.fullname,
      username: UserModule.username,
      userPin: UserModule.fullname,
      siteCode: UserModule.siteCode,
      siteName: UserModule.siteName,
      opened: SappModule.sidebar.opened,
      butsPermission: SappModule.butsPermission
    }
    // console.log(this.microAppData, 'this.dataForChild123')
  },
  methods: {
    getEnvironment() {
      const hostname = window.location.hostname

      switch (hostname) {
        case 'itms.jd.com':
          return 1
        case 'itms-gray.jd.com':
          return 2
        default:
          return 3
      }
    },
    handleDataChange({ detail = {} }) {
      const data = detail.data || {}
      if (data.type === 'routerChange2') {
        // 判断data.info.path是否存在且不等于'/'，并且不包含'st-3pl'字符串
        if (data.info.path && data.info.path !== '/' && data.info.path.indexOf('st-3pl') < 0) {
          // 将data.info.path前面加上'/st-3pl'
          data.info.path = `/st-3pl${data.info.path}`
        }
        // 删除data.info对象中的name属性
        delete data.info.name
        const routerData = JSON.parse(JSON.stringify(data.info))
        this.$nextTick(() => {
          this.$router.push({
            ...routerData,
            query: {
              ...routerData.query,
              ...routerData.params
            }
          })
        })
      } else if (data.type === 'closeAndOpenNewTab') {
      } else if (data.type === 'setPermission') {
      }
    },
    handleCreate() {
      this.ladingFlag = true
    },

    handleBeforeMount() {
      this.ladingFlag = true
    },

    handleMount() {
      console.log('3pl挂载')
      this.ladingFlag = false
      try {
        const contentWrapper = document.querySelector('.content-wrapper')
        if (contentWrapper) {
          contentWrapper.setAttribute('style', 'background-color:#F5F5F6;')
        }
      } catch (e) {
        console.log(e)
      }
    },

    handleUnmount() {
      try {
        const contentWrapper = document.querySelector('.content-wrapper')
        const imgView = document.querySelector('.express-center-box')
        this.$nextTick(() => {
          if (imgView) {
            if (this.$route.path === '/' || this.$route.path === '/helpCenter' || this.$route.path === '/home/welcome') {
              imgView.setAttribute('style', 'margin-left:-100px;')
            } else {
              imgView.setAttribute('style', 'margin-left:0px;')
            }
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    handleError() {
    },
    created() {
      this.ladingFlag = true
    },
    beforeshow() {
      console.log('即将重新渲染，初始化时不执行')
    },
    aftershow() {
      this.ladingFlag = false
      console.log('已经重新渲染，初始化时不执行')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
.pl-app{
   padding: 0px 0 17px 0;
   margin-top: 0px;
   height: calc(100vh - 100px);
   micro-app[name="3pl"] {
    height: 100%;
   }
}
</style>
<style lang="scss">
.pl-app {
  margin-top: 0px;
  .el-scrollbar {
    padding-right: 0!important;
  }
  .circular{
    background-image: url('~@/assets/img/loading.gif');
    width: 300px;
    height: 300px;
   }
   .el-loading-spinner{
      top: 40vh;
      margin-top: -150px;
   }
}
</style>
